<!-- Page Header -->
<div class="page-header" *ngIf="!ocultarCabecalho">
  <div class="header-icon">
    <i class="pi pi-file"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-file-edit tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid de Cards -->
      <div class="registro-tab">
      <div class="cards-container">
        <!-- Coluna Esquerda - Dados do Timbrado -->
        <div class="column-left">
          <div class="form-card">
            <!-- Banner de edicao -->
            <div class="editing-banner" *ngIf="form.id">
              <i class="pi pi-pencil"></i>
              <span>{{ texts.editando_timbrado }}</span>
            </div>
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-file-edit"></i>
              </div>
              <span class="card-header-title">{{ texts.dados_do_timbrado }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Timbrado -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.timbrado }} <span class="required">*</span></label>
                  <input type="text" pInputText digitsOnly inputmode="numeric"
                    [placeholder]="placeholders.timbrado"
                    [(ngModel)]="form.timbrado" class="w-full"
                    [class.p-invalid]="submitted && (!form.timbrado || form.timbrado.trim() === '')" />
                </div>

                <!-- Autorizacao (obrigatoria quando tipoNota for AUTO_IMPRESSOR) -->
                <div class="form-field half">
                  <label class="form-label">
                    {{ labels.autorizacao }}
                    <span class="required" *ngIf="form.tipoNota?.value === 'AUTO_IMPRESSOR'">*</span>
                  </label>
                  <input type="text" pInputText digitsOnly inputmode="numeric"
                    [placeholder]="placeholders.autorizacao"
                    [(ngModel)]="form.autorizacao" class="w-full"
                    [class.p-invalid]="submitted && form.tipoNota?.value === 'AUTO_IMPRESSOR' && (!form.autorizacao || form.autorizacao.trim() === '')" />
                </div>

                <!-- Data Inicio -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.data_inicio }} <span class="required">*</span></label>
                  <p-calendar [(ngModel)]="form.dataInicio" dateFormat="dd/mm/yy"
                    [showIcon]="true" [placeholder]="placeholders.data_inicio"
                    [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2040"
                    [style]="{ 'width': '100%' }" appendTo="body"
                    [class.p-invalid]="submitted && !form.dataInicio">
                  </p-calendar>
                </div>

                <!-- Data Fim (não se aplica ao timbrado ELETRÔNICO) -->
                <div class="form-field half" *ngIf="!ehTipoNotaEletronica">
                  <label class="form-label">{{ labels.data_fim }} <span class="required">*</span></label>
                  <p-calendar [(ngModel)]="form.dataFim" dateFormat="dd/mm/yy"
                    [showIcon]="true" [placeholder]="placeholders.data_fim"
                    [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2040"
                    [style]="{ 'width': '100%' }" appendTo="body"
                    [class.p-invalid]="submitted && !form.dataFim">
                  </p-calendar>
                </div>

                <!-- Ponto de Expedicao -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.ponto_de_expedicao }} <span class="required">*</span></label>
                  <p-inputNumber [(ngModel)]="form.pontoDeExpedicao"
                    [min]="1" [max]="999" [maxlength]="3"
                    [useGrouping]="false" [showButtons]="false"
                    [placeholder]="placeholders.ponto_de_expedicao"
                    styleClass="w-full"
                    [inputStyleClass]="'w-full' + (submitted && (form.pontoDeExpedicao === null || form.pontoDeExpedicao === undefined || +form.pontoDeExpedicao < 1 || +form.pontoDeExpedicao > 999) ? ' p-invalid' : '')">
                  </p-inputNumber>
                </div>

                <!-- Numero Filial -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.numero_filial }} <span class="required">*</span></label>
                  <p-inputNumber [(ngModel)]="form.numeroFilial"
                    [min]="1" [max]="999" [maxlength]="3"
                    [useGrouping]="false" [showButtons]="false"
                    [placeholder]="placeholders.numero_filial"
                    styleClass="w-full"
                    [inputStyleClass]="'w-full' + (submitted && (form.numeroFilial === null || form.numeroFilial === undefined || +form.numeroFilial < 1 || +form.numeroFilial > 999) ? ' p-invalid' : '')">
                  </p-inputNumber>
                </div>

                <!-- Proximo Numero -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.proximo_numero }} <span class="required">*</span></label>
                  <input type="number" pInputText [placeholder]="placeholders.proximo_numero"
                    [(ngModel)]="form.proximoNumero" class="w-full"
                    [class.p-invalid]="submitted && (form.proximoNumero === null || form.proximoNumero === undefined)" />
                </div>

                <!-- Numero Maximo (não se aplica ao timbrado ELETRÔNICO) -->
                <div class="form-field half" *ngIf="!ehTipoNotaEletronica">
                  <label class="form-label">{{ labels.numero_maximo }} <span class="required">*</span></label>
                  <input type="number" pInputText [placeholder]="placeholders.numero_maximo"
                    [(ngModel)]="form.numeroMaximo" class="w-full"
                    [class.p-invalid]="submitted && (form.numeroMaximo === null || form.numeroMaximo === undefined)" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita - Configuracao -->
        <div class="column-right">
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon values-icon">
                <i class="pi pi-cog"></i>
              </div>
              <span class="card-header-title">{{ texts.configuracao }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Tipo de Transacao -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.tipo_de_transacao }} <span class="required">*</span></label>
                  <p-dropdown [options]="tipoDeTransacao" optionLabel="label"
                    [placeholder]="placeholders.tipo_de_transacao"
                    [(ngModel)]="form.tipoDeTransacao" appendTo="body"
                    [class.p-invalid]="submitted && !form.tipoDeTransacao">
                  </p-dropdown>
                </div>

                <!-- Tipo Nota -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.tipo_nota }} <span class="required">*</span></label>
                  <p-dropdown [options]="tipoNota" optionLabel="label"
                    [placeholder]="placeholders.tipo_nota"
                    [(ngModel)]="form.tipoNota" appendTo="body"
                    scrollHeight="300px"
                    [class.p-invalid]="submitted && !form.tipoNota">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="novoTimbrado()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.adicionar"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.atualizar"
          icon="pi pi-check" (click)="salvarEdicaoTimbrado()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_timbrados }}</span>
          <div class="card-header-actions">
            <button pButton [label]="texts.novo_timbrado"
              icon="pi pi-plus" (click)="novoTimbrado()" class="btn-primary btn-sm">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="filterName"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="products" [loading]="loading"
            [customSort]="true"
            (sortFunction)="customSort($event)"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 5%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('timbrado')" pSortableColumn="timbrado" style="width: 12%">
                  {{ labels.timbrado }}<p-sortIcon [field]="'timbrado'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('tipoNota')" pSortableColumn="tipoNota" style="width: 12%">
                  {{ labels.tipo_nota }}<p-sortIcon [field]="'tipoNota'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('tipoDeTransacao')" pSortableColumn="tipoDeTransacao" style="width: 12%">
                  {{ labels.tipo_de_transacao }}<p-sortIcon [field]="'tipoDeTransacao'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('autorizacao')" pSortableColumn="autorizacao" style="width: 12%">
                  {{ labels.autorizacao }}<p-sortIcon [field]="'autorizacao'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('pontoDeExpedicao')" pSortableColumn="pontoDeExpedicao" style="width: 10%">
                  {{ labels.ponto_de_expedicao }}<p-sortIcon [field]="'pontoDeExpedicao'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('numeroFilial')" pSortableColumn="numeroFilial" style="width: 10%">
                  {{ labels.numero_filial }}<p-sortIcon [field]="'numeroFilial'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('proximoNumero')" pSortableColumn="proximoNumero" style="width: 10%">
                  {{ labels.proximo_numero }}<p-sortIcon [field]="'proximoNumero'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('numeroMaximo')" pSortableColumn="numeroMaximo" style="width: 10%">
                  {{ labels.numero_maximo }}<p-sortIcon [field]="'numeroMaximo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-product>
              <tr>
                <td [hidden]="!isColumnVisible('id')">{{ product.id }}</td>
                <td [hidden]="!isColumnVisible('timbrado')">{{ product.timbrado }}</td>
                <td [hidden]="!isColumnVisible('tipoNota')">{{ product.tipoNota.nome }}</td>
                <td [hidden]="!isColumnVisible('tipoDeTransacao')">{{ product.tipoDeTransacao.nome }}</td>
                <td [hidden]="!isColumnVisible('autorizacao')">{{ product.autorizacao }}</td>
                <td [hidden]="!isColumnVisible('pontoDeExpedicao')">{{ product.pontoDeExpedicao }}</td>
                <td [hidden]="!isColumnVisible('numeroFilial')">{{ product.numeroFilial }}</td>
                <td [hidden]="!isColumnVisible('proximoNumero')">{{ product.proximoNumero }}</td>
                <td [hidden]="!isColumnVisible('numeroMaximo')">{{ product.numeroMaximo }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm action-btn edit-btn"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarTimbrado(product)">
                  </button>
                  <button *ngIf="!ocultarExcluir" pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm action-btn delete-btn"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarTimbrado(product.id)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_timbrado }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
                appendTo="body">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
        <p>{{ texts.confirmacao_excluir }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>
  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
